import React from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Notification } from '../../../../../../common/notification'
import { DefaultVsicName } from '../../../DefaultVsicName'
import { SourceLabel } from '../../sourceLabel'
import { selectIds } from '../store/slice'
import { TableFDI } from './TableFDI'
import classes from './index.module.scss'

export const FdiTable = ({ isDynamicReport, column }) => {
  const ids = useSelector(selectIds)

  if (!ids?.length && isDynamicReport) {
    return <Notification isDynamicReport={isDynamicReport} />
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className="flexColumn">
          <Translate
            value="industryOverview.macroeconomics.FDI_GROWTH_RATE_INDUSTRY"
            className="fw600"
          />
          <DefaultVsicName isDynamicReport={isDynamicReport} />
        </div>
      </div>

      <TableFDI isDynamicReport={isDynamicReport} column={column} />
      <SourceLabel isRight />
    </div>
  )
}
